/* jshint node:true */
'use strict';

var debug       = require('debug')('app:action:loadScoreboard');
var loadLeagues = require('./loadLeagues');
var loadHome    = require('./loadHome');
var moment      = require('moment');
var Path        = require('../helpers/utils/path.js');
var apiHost     = require('../helpers/utils/apiHost.js');
//var rugbyAPIHost = 'http://site.api.espn.com';

module.exports = function(context, payload, done) {

    debug('loading scoreboard %s', JSON.stringify([payload]));

    var query = payload.query || {};
    var league = query.league || 'eng.1';
    var dates = query.date  ? query.date : null;
    var request = Path.decode(payload.pathname,payload.query);
    var url = '';
    var sAPIHost = apiHost.get(payload);

    if(!payload.ignoreLeagues){
        context.executeAction(loadLeagues, {sport: request.sport});
    }

    // TODO: Add condition to exec this action only for Rugby scoreboard - 3rd column
    if(!payload.ignoreRHS){
        context.executeAction(loadHome, payload);
    }
	
    // TODO: add cleaner way to build query params
    if(request.sport === 'rugby'){
        if(payload && payload.query && (payload.query.league || payload.query.date)){
            var rugbyLeague = payload.query.league;
            url = sAPIHost + '/apis/site/v2/sports/rugby/' + (rugbyLeague ? rugbyLeague  + '/' : '') + (rugbyLeague ? 'scoreboard' : 'scorepanel') + (payload.query.date ? '?dates=' + payload.query.date : '');
        }else{
            // TODO: remove the dates param (currently being used as the API throws an error without it)
            url = sAPIHost + '/apis/site/v2/sports/rugby/scorepanel';
        }
    }else{
        url = sAPIHost+'/apis/site/v2/sports/' + request.sport + '/' + request.league + '/scoreboard?calendartype=whitelist&&foo' + (dates ?  '&dates=' + dates : '');
    }

    context.service.get({
        url : url,
        done : function(data) {
            data.sport = request.sport;
            context.dispatch('RECEIVED_SCOREBOARD', data);
            done();
        }
    });
};



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/actions/loadScoreboard.js
 **/